
import { Component, Vue } from 'vue-property-decorator';
import LoadingIndicator from '../core/components/Generics/LoadingIndicator.vue';
import ClaimDetailView from './components/ClaimDetailView.vue';
import { ClaimsApi, ClaimDetailResponse } from '../core/api/ClaimsApi';

@Component({
    components: {
        LoadingIndicator,
        ClaimDetailView
    }
})
export default class PageClaimDetail extends Vue {
    pendingInfo: boolean = false;
    errorDetail: boolean = false;
    claimDetail: ClaimDetailResponse | null = null;

    async created(){
        // Load properties first (for translations)
        await this.loadProperties();
        // Then load claim detail
        this.getClaimDetail();
    }

    async loadProperties(){
        try {
            await this.$store.dispatch('properties/loadProperties');
        } catch (error) {
            console.error('Error loading properties:', error);
        }
    }

    getClaimDetail(liftOriginalPolygonRestriction: boolean = false){
        const claimId = parseInt(this.$route.params.id);

        if (!claimId) {
            this.errorDetail = true;
            return;
        }

        this.errorDetail = false;
        this.pendingInfo = true;

        ClaimsApi.getClaimDetail(claimId)
        .then((response: ClaimDetailResponse) => {
            this.claimDetail = liftOriginalPolygonRestriction
                ? { ...response, using_original_polygon: false }
                : response;
        }).catch((error) => {
            console.error('Error fetching claim detail:', error);
            this.errorDetail = true;
            this.claimDetail = null;
        }).finally(() => {
            this.pendingInfo = false;
        })
    }

    goBack(){
        this.$router.push({ name: 'itemWithSinisters' });
    }
}
